import { render, staticRenderFns } from "./VueImageZoomer.vue?vue&type=template&id=c6b8e28e&"
import script from "./VueImageZoomer.vue?vue&type=script&lang=js&"
export * from "./VueImageZoomer.vue?vue&type=script&lang=js&"
import style0 from "./VueImageZoomer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports